// extracted by mini-css-extract-plugin
export var phoneFrame = "HeroPhone-module--phoneFrame--EqqKN";